import { Api } from '@/src/store/api'

export const CardPlatformApi = Api
